import {Directive, Input, OnInit} from "@angular/core";
import moment from "moment";
import {IMetadataImage} from "../../../viewer-components/interfaces/i-metadataimage";
import {ImagesService} from "../../../viewer-components/services/internal-services/images.service";
import {
    ImageGalleryService
} from "../../../viewer-components/services/internal-services/image-gallery/image-gallery.service";
import {ViewerConstants} from "../../../shared/model/viewer-constants";

@Directive()
export abstract class ImageComponentComponent implements OnInit {

    private _image: IMetadataImage;

    @Input()
    set image(value: IMetadataImage) {
        if (!!value) {
            this._image = value;
        }
    }

    get image(): IMetadataImage {
        return this._image;
    }

    @Input() galleryService: ImageGalleryService;

    @Input() enableDebugOptions: boolean;

    @Input() isSelected: boolean;

    @Input() mode: number = -1;

    public captureDate: string;

    public type: string;

    public isLoading = false;

    public obliqueAvailable = true;

    public displayTooltip = false;

    public sizeParameters: string = "";

    ngOnInit() {
        let width: number;
        let height: number;

        if (this.mode === ViewerConstants.IMAGE_GALLERY_MODES.DIALOG) {
            width = document.getElementsByClassName("dialog-image")[0].clientWidth;
            height = ViewerConstants.DOCK_GALLERY_IMG_SIZE.HEIGHT;
        } else if (this.mode === ViewerConstants.IMAGE_GALLERY_MODES.DOCK) {
            width = ViewerConstants.DOCK_GALLERY_IMG_SIZE.WIDTH;
            height = 380;
        }
        this.sizeParameters = this.galleryService.getImageSizeQueryParameters(width, height);
        this.isLoading = true;
        this.captureDate = moment(this._image.capture_date).format("MM/DD/YYYY");
        this.type = ImagesService.getImageResolutionLabel(this._image);
        this.galleryService.obliqueAvailable$.subscribe((obliqueAvailable) => {
            this.obliqueAvailable = obliqueAvailable;
        });
    }
}
